import React, {useState} from 'react';
import {contains} from "underscore";

const ArticleList = (props) => {

    const toggleArticleSelection = (gtin) => {
        let selectedGtins = Object.assign({}, props.selectedGtins);
        if(contains(selectedGtins, gtin)) {
            delete selectedGtins[gtin];
        } else {
            selectedGtins[gtin] = gtin;
        }
        props.setSelection(selectedGtins);
    };

    const toggleAllArticles = () => {
        if(Object.keys(props.selectedGtins).length > 0) {
            props.setSelection({})
        } else {
            let selectedGtins = props.articles.reduce((map, article) => {
                map[article.gtin] = article.gtin;
                return map;
            }, {});
            props.setSelection(selectedGtins);
        }
    };

    const doNothing = () => {};

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="row mt-1">
                    <div className="col-lg-12 pre-scrollable" style={{maxHeight: '500px'}}>
                        <table className="table table-striped" style={{fontSize: 'x-small'}}>
                            <thead>
                            <tr>
                                <th style={{verticalAlign: 'middle'}}>
                                    <input name="selectItem" type="checkbox"
                                           checked={Object.keys(props.selectedGtins).length > 0}
                                           onChange={toggleAllArticles}/>
                                </th>
                                <th>SAP-Artikel</th>
                                <th>Name</th>
                                <th>GTIN</th>
                                <th>Hersteller-Artikelnummer</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {props.articles.map((article, index) => {

                                const isSelected = contains(props.selectedGtins, article.gtin);

                                return (
                                    <tr key={index} onClick={() => toggleArticleSelection(article.gtin)}>
                                        <td style={{verticalAlign: 'middle'}}>
                                            <input name="selectItem" type="checkbox" checked={isSelected} onChange={doNothing} />
                                        </td>
                                        <td>{article.erpIdno}</td>
                                        <td>{article.name}</td>
                                        <td>{article.gtin}</td>
                                        <td>{article.vendorArticleNumber}</td>
                                        <td></td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ArticleList;


// WEBPACK FOOTER //
// ./src/admin/module/admin/ArticleList.js